import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Card, CardText} from 'material-ui/Card';
import compose from 'recompose/compose';
import ViewTitle from 'admin-on-rest/lib/mui/layout/ViewTitle';
import Title from 'admin-on-rest/lib/mui/layout/Title';
import PageDescription from '../components/PageDescription';
import {
    crudUpdate as crudUpdateAction,
} from '../admin/dataActionsLocationInventory';
import DefaultActions from 'admin-on-rest/lib/mui/detail/EditActions';
import translate from 'admin-on-rest/lib/i18n/translate';
import withPermissionsFilteredChildren from 'admin-on-rest/lib/auth/withPermissionsFilteredChildren';

export class EditLocationInventory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            key: 0,
            record: props.data,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            this.setState({record: nextProps.data});
            if (this.fullRefresh) {
                this.fullRefresh = false;
                this.setState({key: this.state.key + 1});
            }
        }
    }

    getBasePath() {
        const {location} = this.props;
        return location.pathname
            .split('/')
            .slice(0, -1)
            .join('/');
    }

    extractDataFromPath() {
        const {location} = this.props;
        const pathArray = location.pathname.split('/');
        return {
            'resource': pathArray[1],
            'location_id': pathArray[2],
            'product': pathArray[3],
            'product_name': pathArray[4],
        };
    }

    defaultRedirectRoute() {
        return 'list';
    }

    save = (record, redirect) => {
        const path = this.extractDataFromPath();
        this.props.crudUpdate(
            this.props.resource,
            this.props.id,
            path.location_id,
            record,
            this.props.data,
            this.getBasePath(),
            redirect
        );
    };

    render() {
        const {
            actions = <DefaultActions/>,
            children,
            data,
            desc,
            hasList,
            isLoading,
            resource,
            title,
            translate,
            version,
        } = this.props;

        if (!children) return null;

        const basePath = this.getBasePath();
        const path = this.extractDataFromPath();

        const titleElement = ({data, path}) ? (
            <Title title={`${title}${path.location_id}`} record={data}
                   defaultTitle={`Add Adjustment for Location: ${path.location_id}`}/>
        ) : (
            ''
        );
        const descriptionElement = data ? (
            <PageDescription record={data} desc={desc}/>
        ) : (
            ''
        );

        return (
            <div className="edit-page">
                <Card style={{opacity: isLoading ? 0.8 : 1}}>
                    {actions &&
                    React.cloneElement(actions, {
                        basePath,
                        data,
                        hasList,
                        resource,
                    })}
                    <ViewTitle title={titleElement}/>
                    {descriptionElement}
                    {data ? (
                        React.cloneElement(children, {
                            save: this.save,
                            resource,
                            basePath,
                            record: data,
                            translate,
                            version,
                            redirect:
                                typeof children.props.redirect === 'undefined'
                                    ? this.defaultRedirectRoute()
                                    : children.props.redirect,
                        })
                    ) : (
                        <CardText>Loading</CardText>
                    )}
                </Card>
            </div>
        );
    }
}

EditLocationInventory.propTypes = {
    actions: PropTypes.element,
    children: PropTypes.node,
    crudUpdate: PropTypes.func.isRequired,
    data: PropTypes.object,
    desc: PropTypes.any,
    hasList: PropTypes.bool,
    id: PropTypes.string,
    type: PropTypes.string,
    location_id: PropTypes.string,
    product: PropTypes.string,
    product_name: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
    title: PropTypes.any,
    translate: PropTypes.func,
    version: PropTypes.number,
};

function extractData(stateData, propMatch) {
    let match = {};
    Object.keys(stateData).map((key) => {
        const dataItem = stateData[key];
        if (
            dataItem.type === propMatch.type &&
            dataItem.location_id === propMatch.location_id &&
            dataItem.product === propMatch.product &&
            dataItem.product_name === propMatch.product_name
        ) {
            match = dataItem;
            return dataItem;
        }
        return match;
    });
    return match;
}

function mapStateToProps(state, props) {
    let resource = state.admin.resources[props.resource];
    let extractedData = {};
    let doUpdate = false;
    if (resource && !props.data) {
        extractedData = extractData(resource.data, props.match.params);
        doUpdate = (extractedData !== props.data);
    }
    if (resource) {
        return {
            type: decodeURIComponent(props.match.params.type),
            location_id: decodeURIComponent(props.match.params.location_id),
            product: decodeURIComponent(props.match.params.product),
            product_name: decodeURIComponent(props.match.params.product_name),
            data: (resource && extractedData && doUpdate) ? extractedData : null,
            isLoading: state.admin.loading > 0,
            version: state.admin.ui.viewVersion,
        };
    }
    return {id: '', type: '', isLoading: true};
}

const enhance = compose(
    connect(mapStateToProps, {
        crudUpdate: crudUpdateAction,
    }),
    translate,
    withPermissionsFilteredChildren
);

export default enhance(EditLocationInventory);


// WEBPACK FOOTER //
// ./src/Fuse/admin/EditLocationInventory.js